import { ref, computed, provide, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-287079c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 2,
  class: "no-chnl-content"
};
import googleDetail from './googleDetail.vue';
import iosDetail from './iosDetail.vue';
import { useRoute } from 'vue-router';
import useDetailHooks from './hooks/useDetailHooks';
import HuaweiDetail from '@/views/goodsManage/goodsSetting/huaweiDetail.vue';
import WxMiniGameDetail from '@/views/goodsManage/goodsSetting/wxMiniGameDetail.vue';
import ZijieMiniGameDetail from '@/views/goodsManage/goodsSetting/zijieMiniGameDetail.vue';
import OppoDetail from '@/views/goodsManage/goodsSetting/oppoDetail.vue';
import XiaomiDetail from '@/views/goodsManage/goodsSetting/xiaomiDetail.vue';
import VivoDetail from '@/views/goodsManage/goodsSetting/vivoDetail.vue';
import FreeDetail from '@/views/goodsManage/goodsSetting/freeDetail.vue';
import KuaishouGameDetail from '@/views/goodsManage/goodsSetting/kuaishouGameDetail.vue';
import AmazonDetail from '@/views/goodsManage/goodsSetting/amazonDetail.vue';
import AlipayMiniGameDetail from '@/views/goodsManage/goodsSetting/alipayMiniGameDetail.vue';
import HonorDetail from '@/views/goodsManage/goodsSetting/honorDetail.vue';
import HarmonyDetail from '@/views/goodsManage/goodsSetting/harmonyDetail.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'goodsSettingDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      basePlanDurationType,
      basePlanBillingCycleType,
      basePlanGracePeriodType,
      basePlanChangesType,
      basePlanResubscribeType,
      getBasicPlanDateOptions
    } = useDetailHooks();
    const route = useRoute();
    const prodChnl = ref('');
    const handleFreeChannel = computed(() => {
      // 正则匹配是否包含
      return ['toutiao', 'tap', 'BanHao'].some(item => prodChnl.value.includes(item));
    });
    const channelComponents = {
      google: googleDetail,
      apple: iosDetail,
      huawei: HuaweiDetail,
      huawei_foreign: HuaweiDetail,
      harmony: HarmonyDetail,
      huawei_runtime_fastgame: HuaweiDetail,
      weixin: WxMiniGameDetail,
      zijie: ZijieMiniGameDetail,
      alipay: AlipayMiniGameDetail,
      oppo: OppoDetail,
      xiaomi: XiaomiDetail,
      vivo: VivoDetail,
      google_amazon: AmazonDetail,
      kuaishou: KuaishouGameDetail,
      honor: HonorDetail,
      hmznb: HarmonyDetail
    };
    const channelComponent = computed(() => channelComponents[prodChnl.value]);
    provide('basePlanDurationType', basePlanDurationType); // 下拉框内容注入下层组件
    provide('basePlanBillingCycleType', basePlanBillingCycleType);
    provide('basePlanGracePeriodType', basePlanGracePeriodType);
    provide('basePlanChangesType', basePlanChangesType);
    provide('basePlanResubscribeType', basePlanResubscribeType);
    onMounted(async () => {
      prodChnl.value = route.query.prodChnl;
      if (prodChnl.value === 'google') {
        await getBasicPlanDateOptions(prodChnl.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_a_empty = _resolveComponent("a-empty");
      return _openBlock(), _createElementBlock("div", null, [_unref(channelComponent) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(channelComponent)), {
        key: 0
      })) : _unref(handleFreeChannel) ? (_openBlock(), _createBlock(FreeDetail, {
        key: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_empty, {
        description: "暂无对应渠道配置"
      })]))]);
    };
  }
});